import React, { useState, useContext, useEffect, useLayoutEffect } from 'react';
import { getHolidaysDefaultItem } from './HolidayAPIEndpoints';
import { PageContext } from '../../../lib/PageProvider';
import { HolidayGridStateful } from "./HolidayGridStateful"
import { HolidayFormDialog } from './HolidayFormDialog';
import { mutateUrls } from "../../../lib/useGenericSWR";
import { useSWRConfig } from "swr";
import { EnsureUser } from '../../auth/EnsureUser';
import { UcToolbar } from '../../common/UcToolbar';
import { UcListPage } from '../../common/UcListPage';
import { useHasPermission } from 'components/auth/PermissionApiEndpoint';
import AddIcon from '@mui/icons-material/Add';
import GroupsIcon from '@mui/icons-material/Groups';
import { useTranslation } from "react-i18next";

export const HolidayListPage = (props) => {
    const { t } = useTranslation();
    const [editDialog, setEditDialog] = useState({ open: false, delete: false, setDefault: false });
    const [selectedItem, setSelectedItem] = useState(null);
    const [pageState, pageDispatch] = useContext(PageContext);
    const [generalSearch, setGeneralSearch] = useState('');

    const [reMutateUrls, setReMutateUrls] = useState(false);
    const swrConfig = useSWRConfig();

    const closeHandler = () => {
        setEditDialog({ open: false, itemToEdit: editDialog.dataItem });
    }

    const saveHandler = () => {
        closeHandler();

        // Also, remutate
        setReMutateUrls(true);
    }

    const openDialog = (dataItem) => {
        if (!dataItem) {
            return;
        }

        if (!dataItem.formIteration) {
            dataItem.formIteration = "edit" + dataItem.id;
        }

        setEditDialog({ open: true, itemToEdit: dataItem, delete: false, setDefault: false });
    }

    const deleteDialog = (dataItem) => {
        if (!dataItem) {
            return;
        }
        if (!dataItem.formIteration) {
            dataItem.formIteration = "delete" + dataItem.id;
        }
        setEditDialog({ open: true, itemToEdit: dataItem, delete: true, setDefault: false });
    }

    const setDefaultDialog = (dataItem) => {
        if (!dataItem) {
            return;
        }

        if (!dataItem.formIteration) {
            dataItem.formIteration = "setDefault" + dataItem.id;
        }

        setEditDialog({ open: true, itemToEdit: dataItem, delete: false, setDefault: true });
    }

    const createItem = () => {
        openDialog(getHolidaysDefaultItem());
    }

    const editItem = (item) => {
        openDialog(item);
    }

    const deleteItem = (item) => {
        deleteDialog(item);
    }

    const setIsDefault = () => {
        setDefaultDialog(selectedItem);
    }

    const actions = [
        {
            icon: <AddIcon data-cy-id={"add_holiday"}/>,
            title: t('Add Holiday'),
            toolTip: t('Add Holiday'),
            onClick: () => { createItem(); },
            isHidden: !useHasPermission("Holiday:Modify"),
            isDisabled: false
        },
        {
            icon: <GroupsIcon />,
            title: t('Set Selected as Default'),
            toolTip: t('Set Selected as Default Holiday'),
            onClick: () => { setIsDefault(); },
            isHidden: !useHasPermission("HolidayDefault:Modify"),
            isDisabled: (selectedItem !== null ? false : true),
            color: 'secondary'
        }
    ];

    useLayoutEffect(() => {
        if (reMutateUrls) {
            mutateUrls(swrConfig);
            setReMutateUrls(false);
        }
    }, [reMutateUrls, swrConfig]);

    useEffect(() => {
        pageDispatch({
            header: "Holidays",
        });
    }, [pageState.header, pageDispatch]);

    console.log("HolidayListPage - Loaded");
    return (
        <UcListPage>
            <EnsureUser permissions={["Holiday:Read"]}>
                <h1 className="pageHeader">{t("Holidays")}</h1>
                <UcToolbar
                    hasGeneralSearch={true}
                    onGeneralSearchChange={(value) => {
                        setGeneralSearch(value);
                    } }
                    actions={actions}>
                </UcToolbar>
                <HolidayFormDialog
                    open={editDialog.open}
                    delete={editDialog.delete}
                    setDefault={editDialog.setDefault}
                    itemToEdit={editDialog.itemToEdit}
                    onCancel={closeHandler}
                    onSave={saveHandler}
                />
                {!reMutateUrls &&
                    <HolidayGridStateful
                    onEditItem={editItem}
                    onDeleteItem={deleteItem}
                    generalSearch={generalSearch}
                    onSelected={(holidayGridSelectedItem) => {
                        setSelectedItem({ ...holidayGridSelectedItem });
                    }} />
                }

            </EnsureUser>
        </UcListPage>
    );
}